<mat-accordion class="example-headers-align" multi>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title class="headerTitle">
                Fluxo {{id}}
            </mat-panel-title>
            <mat-panel-description class="headerDesc">
                <ng-content select="[header]"></ng-content>    
                
            </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-content select="[body]"></ng-content>
    </mat-expansion-panel>
</mat-accordion>

<div class="second-view">
    <ng-content select="[second-view]"></ng-content>
</div>

